import { BaseComponent } from 'components/BaseComponent';
import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { compose } from 'redux';
import { createStructuredSelector } from 'reselect';
import styled from 'styled-components';
import { HBox } from '../../../components/Box';
import { Button } from '../../../components/Buttons';
import { Check, Times } from '../../../components/Icon';
import { setVehicleProperty } from '../actions';

const Container = styled.div``;

const STATE = {};
/* eslint-disable react/prefer-stateless-function */
class SetActionStateButton01Comp extends BaseComponent {
  constructor(props) {
    super(props, {
      ...STATE,
    });
  }

  componentDidMount() {}

  render() {
    return (
      <Container>
        <HBox vCenter left>
          <Button small primary={this.props.vehicle[this.props.propertyName] == '1'} onClick={this.props.activate}>
            <Check />
          </Button>
          <Button small primary={this.props.vehicle[this.props.propertyName] == '0'} onClick={this.props.deactivate}>
            <Times />
          </Button>
          &nbsp;&nbsp;
          {this.lbl(`vehicle.property.${this.props.propertyName}`)}
        </HBox>
      </Container>
    );
  }
}

SetActionStateButton01Comp.propTypes = {
  dispatch: PropTypes.func.isRequired,
};

const mapStateToProps = (state, ownProps) => createStructuredSelector({});

function mapDispatchToProps(dispatch, ownProps) {
  return {
    dispatch,
    activate() {
      dispatch(setVehicleProperty(ownProps.vehicle.id, ownProps.propertyName, '1'));
    },
    deactivate() {
      dispatch(setVehicleProperty(ownProps.vehicle.id, ownProps.propertyName, '0'));
    },
  };
}

const withConnect = connect(
  mapStateToProps,
  mapDispatchToProps,
);

export const SetActionStateButton01 = compose(
  withConnect,
  withRouter,
)(SetActionStateButton01Comp);
